import { MenuButton as ChakraMenuButton, forwardRef } from '@chakra-ui/react';
import type {
  MenuButtonProps as ChakraMenuButtonProps,
  ComponentWithAs,
} from '@chakra-ui/react';

import { Button, type ButtonProps } from '@frontend/components';
import { ChevronDownIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { useMenuContext } from './utils/MenuContext';

export interface MenuButtonProps extends ChakraMenuButtonProps, ButtonProps {}

export const MenuButton: ComponentWithAs<'div', MenuButtonProps> = forwardRef<
  MenuButtonProps,
  'button'
>(
  (
    {
      children,
      as = Button,
      size,
      variant = 'secondary',
      icon = <ChevronDownIcon />,
      ...restProps
    },
    ref,
  ) => {
    const { size: menuContextSize } = useMenuContext();
    return (
      <ChakraMenuButton
        ref={ref}
        as={as}
        size={size != null ? size : menuContextSize}
        variant={variant}
        icon={icon}
        {...restProps}
      >
        {children}
      </ChakraMenuButton>
    );
  },
);
MenuButton.displayName = 'MenuButton';
